module.exports = __webpack_public_path__ + "img/DF.ae799538.png";